
import { popupFullscreen, alertas } from "../ui/ui.js";
const key_user = random_keys();





/*

MODO PRUEBA
const stripe = Stripe("pk_test_51TLkdwDoaiiYQzFEK3zA8ZsTtrmRlacr4sF2pSpBTa9WnNLXCtFpybVcBR0n3LZ9t9RVfI62fzwoa49zJnRARdPN00e1axBU8Q");

MODO REAL
const stripe = Stripe("pk_live_51TLkdwDoaiiYQzFEMMGHkofYAoAUEFWEyhbXCmM56z0De272c9nBJ9BH6bs8RUnWxJgERooa8WyW54ogqnhyDss700FNzzxAsC");




var url_prod = "payment_stripe";
var url_test = "payment_stripe_test";
var url_usd= "payment_stripe_usd";
var url_usd_test= "payment_stripe_test_usd";

*/

/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/

var url_= "payment_stripe_test";

const STRIPE_KEY = Stripe("pk_test_51TLkdwDoaiiYQzFEK3zA8ZsTtrmRlacr4sF2pSpBTa9WnNLXCtFpybVcBR0n3LZ9t9RVfI62fzwoa49zJnRARdPN00e1axBU8Q");










export async function stripe_payment(email, nombre, total_depositos, key_reserva){

  // ===============================
  // 1. RENDERIZAR POPUP STRIPE
  // ===============================
  popupFullscreen({

        type: "info",
        title: "Pago",
        subtitle: "Actividad",
        content: `<style>
       
                    .stripe-submit{
                  background: rgb(30 133 255);
                  color: var(--text);
                  margin: 0 auto;
                  margin-top: 20px;
                  display:block;
                  transition: all 0.3s ease;
                }
                
                /* Estilos cuando el botón está bloqueado/pensando */
                .stripe-submit.loading-active {
                  background: #555555 !important; /* Color grisáceo neutral */
                  cursor: not-allowed;
                  opacity: 0.8;
                }

                /* Animación del Spinner */
                .stripe-spinner {
                  display: inline-block;
                  width: 16px;
                  height: 16px;
                  border: 3px solid rgba(255,255,255,.3);
                  border-radius: 50%;
                  border-top-color: #fff;
                  animation: spin 1s ease-in-out infinite;
                  margin-right: 8px;
                  vertical-align: middle;
                }

                @keyframes spin {
                  to { transform: rotate(360deg); }
                }
          </style>

          <br><br>

          <div class="stripe-wrapper">
            <div class="stripe-container">
              <div class="admin-logo" style="text-align:center; padding:10px;">
                <img style="width:50%;border-radius:10px; margin:0 auto;"
                     src="https://aldorareservations.online/Views/Default/img/aldora/stripe.jpg">
              </div>

              <br><br>

              <div id="stripe-loading" style="text-align:center; padding:20px;">
                Loading Payment...
              </div>

              <form id="payment-form" style="margin: 20px;">

               
               <div style="
                  background:linear-gradient(135deg,#fff8e8,#fffdf7);
                  border:2px solid #f4b400;
                  border-radius:12px;
                  padding:20px;
                  margin-bottom:25px;
                  text-align:center;
                  box-shadow:0 4px 12px rgba(0,0,0,.08);
              ">

                  <div style="
                      font-size:16px;
                      font-weight:700;
                      color:#b26a00;
                      margin-bottom:12px;
                  ">
                      ⚠️ Pago de Depósito
                  </div>

                  <div style="
                      font-size:42px;
                      font-weight:800;
                      color:#1e85ff;
                      margin:10px 0 15px 0;
                  ">
                      €${Number(total_depositos).toFixed(2)}
                  </div>

                  <div style="
                      font-size:15px;
                      line-height:1.6;
                      color:#444;
                  ">
                      Este pago corresponde únicamente al <strong>50% del costo de tu reserva</strong>,
                      el cual garantiza tu lugar en la actividad.
                      <br><br>
                      El importe restante, así como cualquier cargo adicional aplicable
                      (alquiler de equipo, transporte u otros servicios extras),
                      será ajustado y liquidado en persona el día de la actividad.
                  </div>

              </div>



                <div id="link-authentication-element"></div>
                <div id="payment-element"></div>

                <button class="btn stripe-submit" id="submit" type="submit" style="display:none;display: block;
    width: 100%;
    font-size: 24px;
    color: #ffffff;
    border-radius: 20px;
    padding: 10px;">
                  <span id="button-text">
                    Pagar Ahora
                  </span>
                </button>

                <div id="payment-message"></div>
              </form>
            </div>
          </div>`,

           showButtons: false
      });

  // ===============================
  // 2. CONFIGURAR PAYLOAD Y LOCALSTORAGE
  // ===============================
  // Guardamos en localStorage para que 'add_saldo_nuevo' tenga datos que enviar después
  localStorage.setItem("email", email);
  localStorage.setItem("username", nombre);
  localStorage.setItem("key_reserva", key_reserva);





    const amountStripe = Math.round(total_depositos * 100);

    const payload = {
        amount: amountStripe,
        email,
        nombre,
        plan: "pago_cliente_normal",
        referencia_venta: 12,
        key_payment: key_reserva
    };

  let elements;
  let isProcessingPayment = false;

  // ===============================
  // 4. OBTENER FORM Y ASIGNAR EVENTO
  // ===============================
  const form = document.getElementById("payment-form");
  if(!form){
    console.error("payment-form no existe");
    return;
  }

  form.addEventListener("submit", (e) => handleSubmit(e));

  // ===============================
  // 5. INICIALIZAR STRIPE
  // ===============================
  await initialize();

  // ===============================
  // INITIALIZE
  // ===============================
  async function initialize() {
    try{
      const res = await fetch(
        "https://my-first-dive.com/Stripe/" + url_,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );


        const responseText = await res.text();

        let data;

        try {
            data = JSON.parse(responseText);
        } catch (e) {
            console.error("Stripe backend no devolvió JSON:");
            console.error(responseText);
            return;
        }



      const clientSecret = data.clientSecret;
      const paymentIntentId = data.paymentIntentId;

      if(!clientSecret || !paymentIntentId){
        console.error("Stripe no devolvió datos correctos", data);
        return;
      }

      localStorage.setItem("payment_intent_id", paymentIntentId);
      console.log("DATOS STRIPE: id_intent: "+paymentIntentId+" -- clientSecret: "+clientSecret);

      elements = STRIPE_KEY.elements({ clientSecret });

      const paymentElement = document.getElementById("payment-element");
      if(!paymentElement){
        console.error("Elementos Stripe no existen en DOM");
        return;
      }

      const payment = elements.create("payment", { layout: "tabs" });

      const stripeTimeout = setTimeout(() => {
        const loader = document.getElementById("stripe-loading");
        if (loader) {
          loader.innerHTML = "Error cargando el sistema de pago.";
        }

        alertas({
          type: "error",
          title: "Error de conexión",
          message: "No se pudo cargar el sistema de pago. Verifica tu conexión."
        });
      }, 12000);

      // Esperar a que Stripe termine de cargar completamente
      payment.on("ready", () => {
        clearTimeout(stripeTimeout);
        console.log("Stripe listo ✅");

        const loader = document.getElementById("stripe-loading");
        if (loader) loader.remove();

        const submitBtn = document.getElementById("submit");
        if (submitBtn) {
          submitBtn.style.display = "block";
        }
      });

      payment.mount(paymentElement);

    }catch(err){
      console.error("Error inicializando Stripe:", err);
    }
  }

  // ===============================
  // HANDLE SUBMIT
  // ===============================
  async function handleSubmit(e) {
    e.preventDefault();

    if (isProcessingPayment) return; 
    isProcessingPayment = true;
    setLoading(true);

    const { error, paymentIntent } = await STRIPE_KEY.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href
      },
      redirect: "if_required"
    });

    if (error) {
      console.error(error);
      alertas({
        type: "error",
        title: "Payment failed",
        message: error.message
      });

      setLoading(false);
      isProcessingPayment = false;
      return;
    }

    // =========================================
    // MANEJO DE ESTADOS EXITOSOS
    // =========================================
    if (paymentIntent.status === "succeeded" || paymentIntent.status === "processing") {
      
      //  AQUÍ LLAMAS A TU BASE DE DATOS PARA REGISTRAR LA VENTA
      // Como el pago ya se cobró con éxito, registramos el saldo/acceso en Divantys

      alertas({
        type: "success",
        title: "Gracias! Pago Exitoso",
        message: "Espere unos momentos...."
      });

      const msg = document.getElementById("payment-message");
      if(msg) msg.innerHTML = "Procesando su acceso, espere un momento...";

     
      localStorage.removeItem("key_payment");
      localStorage.removeItem("payment_intent_id");

      setTimeout(() => {
        

         window.location.replace("https://my-first-dive.com/Index/Detalles_Reserva/?key_reserva="+key_reserva);


      }, 2500);


    } else {
      alertas({
        type: "error",
        title: "Estado del pago",
        message: "El pago no pudo completarse. Estado: " + paymentIntent.status
      });
    }

    setLoading(false);
    isProcessingPayment = false;
  }

  // ===============================
  // LOADING STATE
  // ===============================
 // ===============================
  // LOADING STATE (ACTUALIZADO)
  // ===============================
  function setLoading(isLoading) {
    const submit = document.getElementById("submit");
    const text = document.getElementById("button-text");
    if(!submit || !text) return;

    if (isLoading) {
      submit.disabled = true;
      submit.classList.add("loading-active"); // Clase para aplicar estilos CSS personalizados
      text.innerHTML = `<span class="stripe-spinner"></span> Wainting...`; 
    } else {
      submit.disabled = false;
      submit.classList.remove("loading-active");
      text.innerHTML = "Pagar Ahora"; // Restauramos el texto original
    }
  }




}








function random_keys(){
  return (
    Date.now().toString(36) +
    Math.random().toString(36).substring(2, 10)
  ).toUpperCase();
}
